export default "__VITE_ASSET__5ld1tdPM__";